module.exports = __webpack_public_path__ + "img/nmc.157229f8.svg";